export default {
  setSupportContext(state, contextId) {
    state.contextId = contextId;
  },
  setSupportProgramContext(state, contextId) {
    state.programContextId = contextId;
  },
  setSupportProgramContextType(state, contextTypeId) {
    state.programContextTypeId = contextTypeId;
  },
};
